"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ServerAPI_1 = require("./ServerAPI");
var EmailAPI_1 = require("./EmailAPI");
var CompanyAPI_1 = require("./CompanyAPI");
var CustomerAPI_1 = require("./CustomerAPI");
var PricingGroupAPI_1 = require("./PricingGroupAPI");
var ProductAPI_1 = require("./Product/ProductAPI");
var ProductLogAPI_1 = require("./ProductLogAPI");
var PaymentAPI_1 = require("./PaymentAPI");
var ReportAPI_1 = require("./Report/ReportAPI");
var ShiftAPI_1 = require("./Shift/ShiftAPI");
var UserAPI_1 = require("./User/UserAPI");
var InventoryAPI_1 = require("./InventoryAPI");
var InvoiceAPI_1 = require("./InvoiceAPI");
var ImageAPI_1 = require("./ImageAPI");
var WooCommerceAPI_1 = require("./WooCommerceAPI");
var ConversionAPI_1 = require("./ConversionAPI");
var TransferAPI_1 = require("./TransferAPI");
var TransferTemplateAPI_1 = require("./TransferTemplateAPI");
var SupplierAPI_1 = require("./SupplierAPI");
var SecurityRoleAPI_1 = require("./SecurityRoleAPI");
var DeviceAPI_1 = require("./DeviceAPI");
var POSListingAPI_1 = require("./POSListingAPI");
var LoyaltyAPI_1 = require("./LoyaltyAPI");
var InventorySnapshotAPI_1 = require("./InventorySnapshotAPI");
var UserPreferencesAPI_1 = require("./UserPreferencesAPI");
var EmployeeHourAPI_1 = require("./EmployeeHour/EmployeeHourAPI");
var LowStockNotificationAPI_1 = require("./LowStockNotificationAPI");
var PaymentQueueAPI_1 = require("./PaymentQueueAPI");
var TransactionAPI_1 = require("./TransactionAPI");
var ComplianceAPI_1 = require("./ComplianceAPI");
var MerrcoAPI_1 = require("./external/MerrcoAPI");
var InventoryLogAPI_1 = require("./InventoryLog/InventoryLogAPI");
var AuditAPI_1 = require("./Audit/AuditAPI");
var CubeAPI_1 = require("./CubeAPI");
var AdminAPI_1 = require("./Admin/AdminAPI");
var ProvinceProductsAPI_1 = require("./ProvinceProducts/ProvinceProductsAPI");
var GiftCardAPI_1 = require("./GiftCardAPI");
var LicensedProducerAPI_1 = require("./LicensedProducerAPI");
exports.LicensedProducerAPI = LicensedProducerAPI_1.LicensedProducerAPI;
var BrandAPI_1 = require("./BrandAPI");
exports.BrandAPI = BrandAPI_1.BrandAPI;
var AuditProductAPI_1 = require("./Audit/AuditProductAPI");
exports.AuditProductAPI = AuditProductAPI_1.AuditProductAPI;
var AuditBatchAPI_1 = require("./Audit/AuditBatchAPI");
exports.AuditBatchAPI = AuditBatchAPI_1.AuditBatchAPI;
var BirchmountAPI_1 = require("./external/BirchmountAPI");
exports.BirchmountAPI = BirchmountAPI_1.BirchmountAPI;
// DO NOT add to API object anymore, it's dangerous as methods overwrite and is polluting
// From now on please just `export { somethingAPI } from './SomethingAPI/'
exports.API = __assign({}, ProvinceProductsAPI_1.ProvinceProductsAPI, CompanyAPI_1.CompanyAPI, ComplianceAPI_1.ComplianceAPI, ProductAPI_1.ProductAPI, ProductLogAPI_1.ProductLogAPI, InvoiceAPI_1.InvoiceAPI, ImageAPI_1.ImageAPI, EmailAPI_1.EmailAPI, WooCommerceAPI_1.WooCommerceAPI, ConversionAPI_1.ConversionAPI, PaymentAPI_1.PaymentAPI, PaymentQueueAPI_1.PaymentQueueAPI, SupplierAPI_1.SupplierAPI, MerrcoAPI_1.MerrcoAPI, AuditAPI_1.AuditAPI, TransactionAPI_1.TransactionAPI, CubeAPI_1.CubeAPI, CustomerAPI_1.CustomerAPI, SecurityRoleAPI_1.SecurityRoleAPI, DeviceAPI_1.DeviceAPI, ReportAPI_1.ReportAPI, ServerAPI_1.ServerAPI, POSListingAPI_1.POSListingAPI, ShiftAPI_1.ShiftAPI, TransferAPI_1.TransferAPI, LoyaltyAPI_1.LoyaltyAPI, PricingGroupAPI_1.PricingGroupAPI, TransferTemplateAPI_1.TransferTemplateAPI, InventorySnapshotAPI_1.InventorySnapshotAPI, UserAPI_1.UserAPI, UserPreferencesAPI_1.UserPreferencesAPI, LowStockNotificationAPI_1.LowStockNotificationAPI, InventoryAPI_1.InventoryAPI, EmployeeHourAPI_1.EmployeeHourAPI, InventoryLogAPI_1.InventoryLogAPI, AdminAPI_1.AdminAPI, GiftCardAPI_1.GiftCardAPI);
//# sourceMappingURL=index.js.map